import React from 'react';

import Container from 'react-bootstrap/Container';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
    gtmId: 'GTM-TDJ3X97'
}

TagManager.initialize(tagManagerArgs)


import './App.scss';

// import './fonts/Uniform_Condensed_Bold.ttf';
// import './fonts/UTM AVOBOLD.TTF';

import Footer from './components/footer';

// import { MessengerChat} from 'react-messenger-chat-plugin';


import { CheckLogin } from './route';

const App = () => {

	return (
		<>
			<div className="wrap">
				<Container fluid={true}>
					<CheckLogin />
				</Container>

			</div>
			<Footer />
		</>
	);
}

export default App;